import { CardBody } from 'reactstrap'

const Body = ({ children }) => <CardBody className="d-flex flex-column">{children}</CardBody>

export default Body
